/* eslint-disable @typescript-eslint/no-unused-vars, react-hooks/exhaustive-deps */
import {getActiveBranchId} from '../utils/branch';
import React,{useState,useEffect}from'react';
import{useNavigate}from'react-router-dom';
import Layout from'../components/layout/Layout';
import StatCard from'../components/common/StatCard';
import Badge from'../components/common/Badge';
import DataTable from'../components/common/DataTable';
import api from'../services/api';
import {getCurrencySymbol} from '../utils/locale';
import {useTranslation} from 'react-i18next';
import FileShaClaimButton from '../components/common/FileShaClaimButton';
import{fmtDate}from'../utils/helpers';

const STATUS_LIST=['SCHEDULED','CHECKED_IN','IN_CONSULTATION','COMPLETED','CANCELLED','NO_SHOW'];

// Helper: get value trying both camelCase and snake_case
const g=(r:any,...keys:string[])=>{
  for(const k of keys){if(r?.[k]!=null&&r[k]!=='')return r[k];}
  return '';
};

export default function AppointmentPage(){
  const {t}=useTranslation();
  const [appointments,setAppointments]=useState<any[]>([]);
  const [loading,setLoading]=useState(false);
  const [stats,setStats]=useState<any>({});
  const navigate=useNavigate();
  const [queue,setQueue]=useState<any[]>([]);
  const [activeTab,setActiveTab]=useState<'list'|'queue'>('queue');
  const [filterStatus,setFilterStatus]=useState('');
  const [msg,setMsg]=useState('');

  useEffect(()=>{
    api.getAppointmentStats?.().then(r=>setStats(r?.data||{})).catch(()=>{});
    loadData();loadQueue();
  },[]);

  const loadData=async()=>{
    setLoading(true);
    try{
      const r=await api.getAppointments({status:filterStatus||undefined,skip:0,take:100,branchId:getActiveBranchId()||undefined});
      const raw=r?.data;
      // Backend returns { appointments:[...], total:N }
      const list=raw?.appointments||raw?.data||( Array.isArray(raw)?raw:[]);
      setAppointments(list.filter(Boolean));
    }catch{}finally{setLoading(false);}
  };

  const loadQueue=async()=>{
    try{
      const r=await api.getTodayQueue?.();
      const raw=r?.data;
      const list=raw?.appointments||raw?.queue||(Array.isArray(raw)?raw:[]);
      setQueue(list.filter(Boolean));
    }catch{}
  };

  useEffect(()=>{loadData();},[filterStatus]);

  const updateStatus=async(id:string,status:string)=>{
    await api.updateAppointmentStatus(id,status);loadData();loadQueue();
  };

  const printSlip=async(apt:any)=>{
    if(!apt)return;
    const{openPrintWindow}=await import('../utils/printUtils');
    const patientName=`${g(apt,'patient_first_name','patientFirstName','firstName')} ${g(apt,'patient_last_name','patientLastName','lastName')}`.trim()||'—';
    const _dfn=g(apt,'doctor_first_name','doctorFirstName');const _dln=g(apt,'doctor_last_name','doctorLastName')||'';const _dRaw=`${_dfn} ${_dln}`.trim();const doctorName=_dRaw?(_dRaw.startsWith('Dr.')?_dRaw:`Dr. ${_dRaw}`):'—';
    const uhid=g(apt,'uhid','patient_uhid')||'—';
    const aptNo=g(apt,'appointment_number','appointmentNumber')||'—';
    const token=g(apt,'token_number','tokenNumber')||'—';
    const rawDate=g(apt,'appointment_date','appointmentDate');
    const date=rawDate?new Date(rawDate).toLocaleDateString('en-KE',{day:'2-digit',month:'short',year:'numeric'}):'—';
    const time=g(apt,'start_time','startTime','appointmentTime').slice(0,5)||'—';
    const fee=+(g(apt,'consultation_fee','consultationFee')||0);
    const dept=g(apt,'specialization','department')||'';
    await openPrintWindow(`
      <div class="section">
        <div class="row"><div class="field"><div class="lbl">${t('common.patient','Patient')}</div><div class="val">${patientName}</div></div><div class="field"><div class="lbl">UHID</div><div class="val">${uhid}</div></div></div>
        <div class="row"><div class="field"><div class="lbl">${t('common.doctor','Doctor')}</div><div class="val">${doctorName}${dept?`<span style="font-size:10px;color:#64748b;display:block">${dept}</span>`:''}</div></div><div class="field"><div class="lbl">${t('appointment.apptNo','Appt #')}</div><div class="val">${aptNo}</div></div></div>
        <div class="row"><div class="field"><div class="lbl">${t('common.date','Date')}</div><div class="val">${date}</div></div><div class="field"><div class="lbl">${t('common.time','Time')}</div><div class="val">${time}</div></div></div>
      </div>
      <div style="text-align:center;margin:12px 0;background:#eff6ff;border:2px solid #2563eb;border-radius:8px;padding:14px;">
        <div style="font-size:48px;font-weight:900;color:#1d4ed8;line-height:1;">${token}</div>
        <div style="font-size:11px;color:#64748b;margin-top:4px;letter-spacing:2px;">${t('appointment.tokenNumber','TOKEN NUMBER')}</div>
      </div>
      <div style="background:#f0fdf4;border:1px solid #16a34a;border-radius:8px;padding:10px 14px;display:flex;justify-content:space-between;align-items:center;">
        <span style="font-size:12px;font-weight:600;color:#15803d;">${t('appointment.consultationFee','Consultation Fee')}</span>
        <span style="font-size:16px;font-weight:800;color:#15803d;">${getCurrencySymbol()}${fee.toLocaleString('en-KE')}</span>
      </div>
      <p style="font-size:10px;color:#94a3b8;text-align:center;margin-top:10px;">${t('appointment.arriveEarlyNote','Please arrive 10 minutes before your appointment time.')}</p>
    `,t('appointment.slipTitle','Appointment Slip'));
  };

  const TRIAGE:Record<string,string>={
    SCHEDULED:'border-l-blue-500 bg-gradient-to-r from-blue-50 to-white',
    CHECKED_IN:'border-l-emerald-500 bg-gradient-to-r from-emerald-50 to-white',
    IN_CONSULTATION:'border-l-amber-500 bg-gradient-to-r from-amber-50 to-white',
    COMPLETED:'border-l-slate-400 bg-gradient-to-r from-slate-50 to-white',
    CANCELLED:'border-l-red-400 bg-gradient-to-r from-red-50 to-white',
    NO_SHOW:'border-l-orange-400 bg-gradient-to-r from-orange-50 to-white',
  };

  const cols=[
    {key:'appt',label:'Appt #',render:(r:any)=>(
      <div>
        <span className="font-mono text-xs text-slate-600">{g(r,'appointment_number','appointmentNumber')||'—'}</span>
        <p className="text-xs text-slate-400 mt-0.5">{fmtDate(g(r,'appointment_date','appointmentDate'))||'—'}</p>
      </div>
    )},
    {key:'token',label:'Token',render:(r:any)=>(
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#02357A]/10 border-2 border-[#02357A]/20">
        <span className="font-black text-[#02357A] text-sm">{g(r,'token_number','tokenNumber')||'—'}</span>
      </div>
    )},
    {key:'patient',label:'Patient',render:(r:any)=>{
      const name=`${g(r,'patient_first_name','patientFirstName')} ${g(r,'patient_last_name','patientLastName')}`.trim();
      const uhid=g(r,'uhid','patient_uhid');
      const phone=g(r,'patient_phone','phone');
      return(
        <div>
          <p className="font-semibold text-slate-800">{name||'—'}</p>
          {uhid&&<p className="text-xs text-[#02357A] font-mono">{uhid}</p>}
          {phone&&<p className="text-xs text-slate-400">📱 {phone}</p>}
        </div>
      );
    }},
    {key:'doctor',label:'Doctor',render:(r:any)=>{
      const fn=g(r,'doctor_first_name','doctorFirstName');
      const ln=g(r,'doctor_last_name','doctorLastName')||'';
      const spec=g(r,'specialization','department');
      // doctor_first_name may already contain 'Dr.' prefix
      const rawName=fn?`${fn} ${ln}`.trim():'—';
      const name=rawName.startsWith('Dr.')?rawName:`Dr. ${rawName}`;
      return(
        <div>
          <p className="font-medium text-sm text-slate-800">{name}</p>
          {spec&&<p className="text-xs text-slate-400">{spec}</p>}
        </div>
      );
    }},
    {key:'time',label:'Time',render:(r:any)=>(
      <div>
        <p className="font-semibold text-slate-700">{g(r,'start_time','startTime','appointmentTime').slice(0,5)||'—'}</p>
        <p className="text-xs text-slate-400">{g(r,'consultation_type','consultationType')||'—'}</p>
      </div>
    )},
    {key:'status',label:'Status',render:(r:any)=><span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-600">{g(r,'status')||'—'}</span>},
    {key:'fee',label:'Fee',render:(r:any)=>{
      const fee=+(g(r,'consultation_fee','consultationFee')||0);
      return<span className="font-semibold text-slate-700">{fee?`${getCurrencySymbol()}${fee.toLocaleString('en-KE')}`:'—'}</span>;
    }},
    {key:'actions',label:'Actions',render:(r:any)=>{
      const status=g(r,'status');
      const pid=g(r,'patient_id','patientId');
      return(
        <div className="flex gap-1.5 flex-wrap">
          {status==='SCHEDULED'&&<button onClick={()=>updateStatus(r.id,'CHECKED_IN')} className="text-xs bg-emerald-500 hover:bg-emerald-600 text-white px-2 py-1 rounded-lg font-medium">✅ Check In</button>}
          {status==='CHECKED_IN'&&<button onClick={()=>updateStatus(r.id,'IN_CONSULTATION')} className="text-xs bg-amber-500 hover:bg-amber-600 text-white px-2 py-1 rounded-lg font-medium">▶ Start</button>}
          {status==='IN_CONSULTATION'&&<button onClick={()=>updateStatus(r.id,'COMPLETED')} className="text-xs bg-[#02357A] hover:bg-[#015CA6] text-white px-2 py-1 rounded-lg font-medium">✓ Done</button>}
          {status==='SCHEDULED'&&<button onClick={()=>updateStatus(r.id,'CANCELLED')} className="text-xs bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-lg font-medium">✕</button>}
          <button onClick={()=>printSlip(r)} title="Print Slip"
            className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-700 px-2 py-1 rounded-lg font-medium">🖨️</button>
          <button onClick={()=>navigate('/billing',{state:{patientId:pid,appointmentId:r.id}})} title="Bill"
            className="text-xs bg-green-50 hover:bg-green-100 text-green-700 border border-green-200 px-2 py-1 rounded-lg font-medium">💰 Bill</button>
          <button onClick={()=>navigate('/doctor/emr',{state:{patientId:pid}})} title="EMR"
            className="text-xs bg-blue-50 hover:bg-blue-100 text-[#02357A] border border-blue-200 px-2 py-1 rounded-lg font-medium">🩺 EMR</button>
        </div>
      );
    }},
  ];

  return(
    <Layout title="Appointment Management" actions={
      <button onClick={()=>navigate('/appointments/book')} className="bg-[#02357A] hover:bg-[#015CA6] text-white font-semibold py-2.5 px-5 rounded-xl transition-all text-sm shadow-md shadow-[#02357A]/20 disabled:opacity-50 disabled:cursor-not-allowed px-5">
        📅 Book Appointment
      </button>
    }>
      {msg&&<div className={`mb-4 p-3 rounded-lg text-sm ${msg.startsWith('✅')?'bg-green-50 text-green-700 border border-green-200':'bg-red-50 text-red-700 border border-red-200'}`}>{msg}</div>}

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 text-center"><p className="text-2xl font-black text-slate-800">—</p></div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 text-center"><p className="text-2xl font-black text-slate-800">—</p></div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 text-center"><p className="text-2xl font-black text-slate-800">—</p></div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 text-center"><p className="text-2xl font-black text-slate-800">—</p></div>
      </div>

      {/* Tabs */}
      <div className="flex gap-2 mb-4">
        {(['queue','list'] as const).map(t=>(
          <button key={t} onClick={()=>setActiveTab(t)}
            className={`px-5 py-2 rounded-xl text-sm font-semibold transition-all ${activeTab===t?'bg-[#02357A] text-white shadow-md':'bg-white text-slate-600 border border-slate-200 hover:border-[#02357A] hover:text-[#02357A]'}`}>
            {t==='queue'?"🏥 Today's Queue":'📋 All Appointments'}
            {t==='queue'&&queue.length>0&&<span className={`ml-2 text-xs px-2 py-0.5 rounded-full ${activeTab==='queue'?'bg-white/20':'bg-[#02357A]/10 text-[#02357A]'}`}>{queue.length}</span>}
          </button>
        ))}
      </div>

      {/* Queue */}
      {activeTab==='queue'&&(
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {queue.length===0?(
            <div className="col-span-3 bg-white rounded-2xl border p-16 text-center shadow-sm">
              <span className="text-6xl block mb-4">📅</span>
              <p className="text-lg font-semibold text-slate-600 mb-2">No appointments today</p>
              <p className="text-slate-400 text-sm mb-6">Book an appointment to get started</p>
              <button onClick={()=>navigate('/appointments/book')} className="bg-[#02357A] hover:bg-[#015CA6] text-white font-semibold py-2.5 px-5 rounded-xl transition-all text-sm shadow-md shadow-[#02357A]/20 disabled:opacity-50 disabled:cursor-not-allowed px-6">📅 Book Appointment</button>
            </div>
          ):queue.map((apt:any)=>apt&&(
            <div key={apt.id} className={`rounded-2xl border-l-4 border border-slate-100 p-4 shadow-sm hover:shadow-md transition-all ${TRIAGE[apt?.status]||'bg-white'}`}>
              {/* Header */}
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-3xl font-black text-[#02357A]">{g(apt,'token_number','tokenNumber')||'—'}</span>
                    <span className="text-xs text-slate-400 bg-white/80 px-2 py-0.5 rounded-full border">Token</span>
                  </div>
                  <p className="text-xs text-slate-400 mt-0.5">Queue #{g(apt,'queue_number','queueNumber')||'—'}</p>
                </div>
                <span className="text-xs font-semibold px-2.5 py-1 rounded-full bg-slate-100 text-slate-600">{apt?.status||'—'}</span>
              </div>

              {/* Patient */}
              <div className="mb-2">
                <p className="font-bold text-slate-800 text-base">
                  {`${g(apt,'patient_first_name','patientFirstName')||''} ${g(apt,'patient_last_name','patientLastName')||''}`.trim()||'Unknown'}
                </p>
                <p className="text-xs text-[#02357A] font-mono">{g(apt,'uhid','patient_uhid')||''}</p>
              </div>

              {/* Doctor */}
              {g(apt,'doctor_first_name','doctorFirstName')&&(
                <p className="text-xs text-slate-500 mb-1">
                  👨‍⚕️ {(()=>{const fn=g(apt,'doctor_first_name','doctorFirstName');const ln=g(apt,'doctor_last_name','doctorLastName')||'';const n=`${fn} ${ln}`.trim();return n.startsWith('Dr.')?n:`Dr. ${n}`;})()}
                  {g(apt,'specialization')&&<span className="text-slate-400"> · {g(apt,'specialization')}</span>}
                </p>
              )}

              {/* Reason */}
              {g(apt,'reason_for_visit','reasonForVisit')&&(
                <p className="text-xs text-slate-500 mb-1 line-clamp-1">📋 {g(apt,'reason_for_visit','reasonForVisit')}</p>
              )}

              {/* Time */}
              <p className="text-xs text-slate-500 mb-3">
                ⏰ {g(apt,'start_time','startTime','appointmentTime').slice(0,5)||'—'} · {g(apt,'consultation_type','consultationType')||'OPD'}
              </p>

              {/* Actions */}
              <div className="flex gap-2">
                {apt?.status==='SCHEDULED'&&(
                  <button onClick={()=>updateStatus(apt.id,'CHECKED_IN')}
                    className="flex-1 bg-emerald-500 hover:bg-emerald-600 text-white text-xs font-semibold py-2 rounded-xl transition-all">
                    ✅ Check In
                  </button>
                )}
                {apt?.status==='CHECKED_IN'&&(
                  <button onClick={()=>updateStatus(apt.id,'IN_CONSULTATION')}
                    className="flex-1 bg-amber-500 hover:bg-amber-600 text-white text-xs font-semibold py-2 rounded-xl transition-all">
                    ▶ Start Consult
                  </button>
                )}
                {apt?.status==='IN_CONSULTATION'&&(
                  <button onClick={()=>updateStatus(apt.id,'COMPLETED')}
                    className="flex-1 bg-[#02357A] hover:bg-[#015CA6] text-white text-xs font-semibold py-2 rounded-xl transition-all">
                    ✓ Complete
                  </button>
                )}
                <button onClick={()=>navigate('/doctor/emr',{state:{patientId:g(apt,'patient_id','patientId')}})}
                  className="bg-blue-50 hover:bg-blue-100 text-[#02357A] border border-blue-200 text-xs font-semibold px-3 py-2 rounded-xl transition-all">
                  🩺
                </button>
                <FileShaClaimButton
                  patientId={g(apt,'patient_id','patientId')}
                  patientName={`${g(apt,'patient_first_name','patientFirstName')||''} ${g(apt,'patient_last_name','patientLastName')||''}`.trim()}
                  encounterId={apt.id}
                  serviceName={g(apt,'reason_for_visit','reasonForVisit')||'OPD appointment'}
                  from="appointment"
                />
                <button onClick={()=>printSlip(apt)}
                  className="bg-slate-100 hover:bg-slate-200 text-slate-600 text-xs font-semibold px-3 py-2 rounded-xl transition-all">
                  🖨️
                </button>
                <button onClick={()=>navigate('/billing',{state:{patientId:g(apt,'patient_id','patientId'),appointmentId:apt.id}})}
                  className="bg-green-50 hover:bg-green-100 text-green-700 border border-green-200 text-xs font-semibold px-3 py-2 rounded-xl transition-all">
                  💰
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* List */}
      {activeTab==='list'&&(
        <div className="bg-white rounded-2xl border shadow-sm overflow-hidden">
          <div className="p-4 border-b flex gap-2 items-center flex-wrap bg-gray-50/50">
            <h3 className="font-bold text-slate-700 mr-3">All Appointments</h3>
            {STATUS_LIST.map(s=>(
              <button key={s} onClick={()=>setFilterStatus(s===filterStatus?'':s)}
                className={`text-xs px-3 py-1.5 rounded-full border font-medium transition-all ${filterStatus===s?'bg-[#02357A] text-white border-[#02357A]':'border-slate-200 text-slate-500 hover:border-[#02357A] hover:text-[#02357A]'}`}>
                {s.replace('_',' ')}
              </button>
            ))}
            {filterStatus&&<button onClick={()=>setFilterStatus('')} className="text-xs text-slate-400 hover:text-red-500 ml-1">✕ Clear</button>}
          </div>
          <DataTable columns={cols} data={appointments} loading={loading} emptyMessage="No appointments found" emptyIcon="📅" hideSearch={false}/>
        </div>
      )}
    </Layout>
  );
}
